import { useEffect, useRef, useState } from "react";
import { PrimaryInput } from "pages/client/signup-page-new/components/primary-input";

import * as S from "./styled";

export const AutocompleteInput = ({
  containerClassName,
  labelClassName,
  label,
  register,
  value,
  children,
  showBorder = false,
  ...rest
}) => {
  const [selectOpen, setSelectOpen] = useState(false);
  const justSelectedRef = useRef(false);

  const onBlur = () => setSelectOpen(false);
  const onFocus = () => {
    if (value?.trim()) setSelectOpen(true);
  };

  // Touchpad taps fire blur before click, which unmounts the dropdown before onClick can fire.
  // preventDefault on mousedown keeps input focused so the click event reaches dropdown items.
  const onDropdownMouseDown = (e) => e.preventDefault();

  const onDropdownClick = () => {
    justSelectedRef.current = true;
    setSelectOpen(false);
  };

  // Show dropdown when user types; suppress reopen after item selection.
  useEffect(() => {
    if (justSelectedRef.current) {
      justSelectedRef.current = false;
      return;
    }
    setSelectOpen(!!value?.trim());
  }, [value]);

  return (
    <S.Container className={`${containerClassName}`}>
      <PrimaryInput
        className={"!text-[#A0A5AF]"}
        label={label}
        labelClassName={labelClassName}
        register={register}
        showBorder={showBorder}
        onBlur={onBlur}
        onFocus={onFocus}
        {...rest}
      />
      {selectOpen && (
        <S.Box className="pac-container" onClick={onDropdownClick} onMouseDown={onDropdownMouseDown}>
          {children}
        </S.Box>
      )}
    </S.Container>
  );
};
